var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.isNull)?_c('h5',{staticClass:"header"},[_vm._v("Adauga vopsire")]):_c('h5',{staticClass:"header"},[_vm._v("Editeaza vopsire")]),(_vm.currentOferta)?_c('EditVopsit',{attrs:{"vopsit_obj":_vm.isNull ? _vm.vopsit : _vm.currentOferta.vopsit_obj,"tip":'oferta',"id":_vm.currentOferta.id_oferta}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }